import { useCallback } from 'react';
import { prop } from 'ramda';
import { get } from 'js/utils/fetch.util';
import { IGamesFeed } from 'js/hooks/games/types';
import { useGetCMSResourceURL } from 'js/hooks/useGetCMSResourceURL';
import { parseGamesFeed } from 'js/hooks/games/hooks/useGetGamesFeed/helpers';
import { useAppSelector, useDeviceSelector, useGameConfigurationSelector } from 'js/store/hooks';

export const useGetGamesFeed = () => {
    const getCMSResourceURL = useGetCMSResourceURL();
    const formFactor = useDeviceSelector(prop('formFactor'));
    const requestStamp = useAppSelector(prop('requestStamp'));
    const gamesFeeds = useGameConfigurationSelector(prop('gamesFeeds'));

    return useCallback(async (feedName: string, disableCache?: boolean): Promise<IGamesFeed> => {
        if (gamesFeeds[feedName] && !disableCache) {
            return gamesFeeds[feedName];
        }

        const requestURL = getCMSResourceURL(`/initialResources/gamesFeeds/${encodeURIComponent(feedName)}`, { t: requestStamp });
        const response = await get(requestURL);

        return parseGamesFeed({ gamesFeed: response, formFactor });
    }, [requestStamp, getCMSResourceURL, formFactor, gamesFeeds]);
};
